import React from "react";
import { Outlet } from "react-router-dom";

function EventDetailLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default EventDetailLayout;
